'use client';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { useTracker } from '@lichtblick/tracker';
import { type FC, type PropsWithChildren, useCallback } from 'react';

export const Anchor: FC<PropsWithChildren<{ href?: string }>> = ({ children, href }) => {
  const { trackCustomEvent } = useTracker();

  const clickHandler = useCallback(() => {
    trackCustomEvent({ eventName: 'tariff_calculator_show_tariffs', customProps: { product: 'Energielösungen' } });
  }, [trackCustomEvent]);

  return (
    <TextCTA
      as="a"
      href={href || '/zuhause/solar/'}
      inlineLink
      onClick={clickHandler}
      data-dd-action-name="Calculator submit: energy-solutions"
    >
      {children}
    </TextCTA>
  );
};
